import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';

import Modal from '../../../Modal';
import ActionButton from '../../../ActionButton';
import { errorContent } from '../../../../utils/errorCodes';
import { setCriticalError } from '../../../../sagas/layout/actions';
import { routes } from '../../../../pages';
import './_criticalModal.scss';

const CriticalModal = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [content, updateContent] = useState({ message: '', btn1: '', action1: null });
  const { criticalError: { status, data } } = useSelector(s => s.layout);
  const [reloadTime, setReloadTime] = useState(null);

  useEffect(() => {
    if (status) {
      updateContent(errorContent(status, data));
    }
  }, [status]);  // eslint-disable-line

  useEffect(() => {
    setReloadTime(content.reloadTime);
  }, [content]); // eslint-disable-line

  useEffect(() => {
    const reloadTimeInterval = setInterval(() => {
      if (reloadTime && reloadTime > 0) {
        setReloadTime(reloadTime - 1);
      } else {
        clearInterval(reloadTimeInterval);
      }
    },1000);

    return () => clearInterval(reloadTimeInterval);
  }, [reloadTime]);  // eslint-disable-line

  const getAction = action => {
    dispatch(setCriticalError({ status: null, headers: {} }));

    if (action === 0) window.location.href = routes.login.business.path;
    if (action === 1) window.location.href = routes.root.path;
    if (action === 2) history.goBack();
  };

  return (
    <Modal open={Boolean(status)} disableClose>
      <div className="criticalModal">
        <Typography>Status Code: <span>{status}</span></Typography>
        <Typography className="message">{data && data.detail ? data.detail : content.message}</Typography>
        {data && data.sentry_event_id && <Typography className="eventId">Event ID: {data.sentry_event_id}</Typography>}
        <div className="btn-container">
          {content.btn2 && <ActionButton variant="outlined" title={content.btn2} onClick={() => getAction(content.action2)} />}
          {content.btn1 && <ActionButton title={`${content.btn1}${reloadTime ? ` (${reloadTime})` : ''}`} onClick={() => getAction(content.action1)} />}
        </div>
      </div>
    </Modal>
  );
};

export default CriticalModal;